import { Avatar, Box, Button, Card, Chip, CircularProgress, Grid, IconButton, Skeleton, Typography } from "@mui/material";
import MainContainer from "theme/MainConatiner";
import {
    ChatBubbleOutline,
    OutlinedFlag,
    CheckCircleOutline,
    StarBorder,
    AccessTime,
} from "@mui/icons-material";
import './style.css'
import CustomSearch from "components/Fileds/CustomSearch";
import CustomSelect from "components/Fileds/CustomSelect";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useRef, useState } from "react";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import theme from "theme/ThemeContext";
import dayjs from "dayjs";
import ReviewDetailsModal from "components/Modal/ReviewDetails/ReviewDetails";
import { CustomPagination } from "components/TableListing/CommonTable";
import CustomTypography from "components/Fileds/CustomTypography";
import ReviewReportModal from "components/Modal/ReviewReport/ReviewReport";
import HeaderTilteBar from "components/TitleBar/HeaderTilteBar";

const emojiRatings = [
    { id: "1", label: "😡" },
    { id: "2", label: "😞" },
    { id: "3", label: "😐" },
    { id: "4", label: "😊" },
    { id: "5", label: "🤩" },
];

const ReviewSkeleton = () => {
    return (
        <Card className="review-card" sx={{ cursor: "default", pointerEvents: "none" }}>
            {/* Header */}
            <Box className="review-card-header">
                <Box className="review-user-info">
                    <Skeleton variant="circular" width={35} height={35} />
                    <Box>
                        <Skeleton variant="text" width={120} height={20} />
                        <Skeleton variant="text" width={80} height={15} />
                    </Box>
                </Box>
                <Box className="report-wrapper">
                    <Skeleton variant="rectangular" width={60} height={20} sx={{ borderRadius: "4px" }} />
                </Box>
            </Box>

            {/* Rating Icons */}
            <Box className="rating-wrapper" sx={{ mt: 1 }}>
                {/* <Box sx={{ display: 'flex', gap: '4px' }}>
                    {[1, 2, 3, 4, 5].map((item) => (
                        <Skeleton key={item} variant="circular" width={36} height={36} />
                    ))}
                </Box> */}
                <Skeleton variant="text" width={100} height={15} />
            </Box>

            {/* Review Text */}
            <Box sx={{ mt: 1.5, mb: 1 }}>
                <Skeleton variant="text" width="90%" height={18} />
                <Skeleton variant="text" width="60%" height={18} />
            </Box>

            {/* Status */}
            <Skeleton variant="rectangular" width={110} height={24} sx={{ borderRadius: "20px", mt: 1.5 }} />
        </Card>
    );
};

const ManageReviewsContainer = ({
    ratingsOptions,
    statusOptions,
    status,
    setStatus,
    setReviewDetailsModal,
    reviewDetailsModal,
    setReviewReportModal,
    reviewReportModal,
    feedbackdata,
    handleReviewDetailsModal,
    handleReviewReportModal,
    reviewData,
    setSearch,
    search,
    searchLoader,
    loading,
    rowCount,
    setPaginationModel,
    paginationModel,
    ratings,
    setRatings,
    handleClearFilter,
    openFrom,
    setOpenFrom,
    openTo,
    setOpenTo,
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    toAnchorRef,
    fromAnchorRef,
    handleApplyFilter,
    appliedFromDate,
    appliedToDate
}) => {

    const showNoData = !loading && (!feedbackdata?.records || feedbackdata.records.length === 0);

    const statsData = [
        {
            id: 1,
            title: "Total Reviews",
            value: feedbackdata?.stats?.totalReviews,
            icon: <ChatBubbleOutline size={22} sx={{ color: "#333" }} />,
        },
        {
            id: 2,
            title: "Avg Rating",
            value: feedbackdata?.stats?.avgRating,
            icon: <StarBorder size={22} sx={{ color: "#f4b400" }} />,
        },
        {
            id: 3,
            title: "Replied",
            value: feedbackdata?.stats?.replied,
            icon: <CheckCircleOutline size={22} sx={{ color: "#16a34a" }} />,
        },
        {
            id: 4,
            title: "Reported",
            value: feedbackdata?.stats?.replied,
            icon: <OutlinedFlag size={22} sx={{ color: "#dc2626" }} />,
        },
    ];

    return (
        <MainContainer>
            <Card className="manage-reviews-page">
                <HeaderTilteBar
                    title="Manage Reviews"
                    isSearch={false}
                    isAddVisible={false}
                    rightContent={
                        <Box className="stats-wrapper">
                            {statsData.map((item) => (
                                <Card className="stats-card" key={item.id}>
                                    <Avatar className="stats-icon">
                                        {item.icon}
                                    </Avatar>

                                    <Box className="stats-content">
                                        <CustomTypography className="stats-value" label={item.value} />
                                        <CustomTypography variant="body2" className="stats-title" label={item.title} />
                                    </Box>
                                </Card>
                            ))}
                        </Box>
                    }
                />

                <Box className="review-filter-wrapper">
                    <Box className="review-search-field">
                        {/* Search Input */}
                        <CustomSearch
                            placeholder={"Search by customer name or review content"}
                            onSearchChange={setSearch}
                            searchQuery={search}
                            isLoading={searchLoader}
                            sx={{
                                '& .MuiInputBase-input, & .MuiOutlinedInput-input': {
                                    paddingTop: '9.5px',
                                    paddingBottom: "12px"
                                },
                            }}
                        />
                    </Box>

                    <Box className="review-filter">
                        <CustomSelect
                            name="ratings"
                            options={ratingsOptions}
                            value={ratings}
                            onChange={(e) => setRatings(e.target.value)}
                            sx={{ borderRadius: '10px', backgroundColor: '#fff', fontSize: '14px', height: "39.5px" }}
                        />

                        <CustomSelect
                            name="status"
                            value={status}
                            options={statusOptions}
                            onChange={e => setStatus(e.target.value)}
                            sx={{ borderRadius: '10px', backgroundColor: '#fff', fontSize: '14px', height: "39.5px" }}
                        />

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DesktopDatePicker
                                open={openFrom}
                                value={fromDate}
                                onClose={() => setOpenFrom(false)}
                                onChange={(newDate) => {
                                    setFromDate(newDate);
                                    setOpenFrom(false);
                                }}
                                maxDate={toDate || undefined}

                                // ===> this hides the default TextField completely
                                slots={{ textField: () => null }}
                                // slotProps={{
                                //     popper: {
                                //         anchorEl: fromAnchorRef.current,
                                //         placement: "bottom-start",
                                //         disablePortal: false,
                                //     },
                                // }}

                                slotProps={{
                                    popper: {
                                        anchorEl: fromAnchorRef.current,
                                        placement: 'bottom-start',
                                        disablePortal: false,     // keep it in the body portal
                                        modifiers: [
                                            {
                                                name: 'offset',
                                                options: { offset: [0, 4] }, // a few pixels below
                                            },
                                            {
                                                name: 'preventOverflow',
                                                options: { boundary: 'viewport' },
                                            },
                                        ],
                                    },
                                }}
                            />

                            {/*  2) Your button, which is the *only* visible thing  */}
                            <Button
                                ref={fromAnchorRef}
                                fullWidth
                                variant="outlined"
                                onClick={() => setOpenFrom((prev) => !prev)}
                                sx={{
                                    justifyContent: 'flex-start',
                                    textTransform: 'none',
                                    // color: "#757575",
                                    // borderColor: theme.palette.divider,
                                    padding: '10px 14px',
                                    height: '40px',
                                    borderRadius: '8px',
                                    fontWeight: 400,
                                    fontSize: '14px',
                                    background: "#ffffff"
                                }}
                                startIcon={<CalendarMonthIcon fontSize="small" sx={{ color: "#757575" }} />}
                            >
                                {fromDate ? dayjs(fromDate).format("DD MMM YYYY") : "From Date"}
                            </Button>

                            <DesktopDatePicker
                                open={openTo}
                                value={toDate}
                                onClose={() => setOpenTo(false)}
                                onChange={(newDate) => {
                                    setToDate(newDate);
                                    // setDateError("");
                                    setOpenTo(false);
                                }}
                                minDate={fromDate || undefined}
                                // ===> this hides the default TextField completely
                                slots={{ textField: () => null }}
                                // slotProps={{
                                //     popper: {
                                //         anchorEl: toAnchorRef.current,
                                //         placement: "bottom-start",
                                //         disablePortal: false,
                                //     },
                                // }}
                                slotProps={{
                                    popper: {
                                        anchorEl: toAnchorRef.current,
                                        placement: 'bottom-start',
                                        disablePortal: false,     // keep it in the body portal
                                        modifiers: [
                                            {
                                                name: 'offset',
                                                options: { offset: [0, 4] }, // a few pixels below
                                            },
                                            {
                                                name: 'preventOverflow',
                                                options: { boundary: 'viewport' },
                                            },
                                        ],
                                    },
                                }}
                            />

                            {/*  2) Your button, which is the *only* visible thing  */}
                            <Button
                                ref={toAnchorRef}
                                fullWidth
                                variant="outlined"
                                onClick={() => setOpenTo((prev) => !prev)}
                                sx={{
                                    justifyContent: 'flex-start',
                                    textTransform: 'none',
                                    // color: "#757575",
                                    // borderColor: theme.palette.divider,
                                    padding: '10px 14px',
                                    height: '40px',
                                    borderRadius: '8px',
                                    fontWeight: 400,
                                    fontSize: '14px',
                                    background: "#ffffff"
                                }}
                                startIcon={<CalendarMonthIcon fontSize="small" sx={{ color: "#757575" }} />}
                            >
                                {toDate ? dayjs(toDate).format("DD MMM YYYY") : "To Date"}
                            </Button>

                            {(fromDate || toDate) &&
                                <Button
                                    variant="contained"
                                    onClick={handleApplyFilter}
                                    sx={{
                                        height: "40px",
                                        borderRadius: "8px",
                                        textTransform: "none",
                                        // minWidth: "120px",
                                    }}
                                >
                                    Apply
                                </Button>
                            }

                            {/* CLEAR BUTTON */}
                            {(appliedFromDate || appliedToDate) && (
                                <Button
                                    variant="outlined"
                                    onClick={handleClearFilter}
                                    sx={{
                                        height: "40px",
                                        borderRadius: "8px",
                                        textTransform: "none",
                                        // minWidth: "120px",
                                    }}
                                >
                                    Clear
                                </Button>
                            )}
                        </LocalizationProvider>
                    </Box>
                </Box>

                <CustomTypography sx={{ mt: 2, color: "#757575" }} label={`${rowCount} Reviews Found`} />

                {/* Scrollable Reviews List Body */}
                <Box className="reviews-list-body">
                    {loading ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                            {[1, 2, 3].map((idx) => (
                                <ReviewSkeleton key={idx} />
                            ))}
                        </Box>
                    ) : showNoData ?
                        /* No Search Result */
                        <Box className="body-wrapper empty-wrapper">
                            <ChatBubbleOutline sx={{ color: "#ccc", mb: 1, fontSize: 40 }} />
                            <CustomTypography className="empty-title" label="No review matches your filter" />
                        </Box>
                        : (
                            feedbackdata?.records?.map((val, index) => (
                                <Card className="review-card" key={val?.id ?? index} onClick={() => handleReviewDetailsModal(val)}>
                                    {/* Header */}
                                    <Box className="review-card-header">
                                        <Box className="review-user-info">
                                            <Avatar
                                                className="review-avatar"
                                                src={`${process.env.REACT_APP_API_ROUTE}/files/${val?.customer?.profile_pic}` || ""}
                                            >
                                                {!val?.customer?.profile_pic && val?.customer?.name?.split(" ").map((word) => word[0]).join("").toUpperCase()}
                                            </Avatar>
                                            <Box>
                                                <CustomTypography sx={{ fontSize: 15, fontWeight: 500, color: "#333" }} label={val?.customer?.name} />
                                                <CustomTypography variant="body2" className="review-order-id" label={`#${val?.orderDetails?.order_id}`} />
                                            </Box>
                                        </Box>
                                        <Box>
                                            {val?.is_reported ?
                                                <Chip
                                                    icon={
                                                        <OutlinedFlag
                                                            sx={{
                                                                color: '#fff !important', // red
                                                                fontSize: 20,     // icon size
                                                            }}
                                                        />
                                                    }
                                                    label="Reported"
                                                    className="report-chip"
                                                />
                                                :
                                                <Button
                                                    variant="outlined"
                                                    startIcon={<OutlinedFlag />}
                                                    className="report-btn"
                                                    onClick={(e) => handleReviewReportModal(e, val)}
                                                >
                                                    Report
                                                </Button>
                                            }
                                            <CustomTypography className="review-date" sx={{ mt: 1 }} label={dayjs(val?.created_at).format("YYYY-MM-DD HH:mm")} />
                                        </Box>
                                    </Box>

                                    {/* Rating Icons */}
                                    <Box className="rating-wrapper">
                                        <Box className="rating-emojis">
                                            {emojiRatings.map((item) => (
                                                <span
                                                    key={item.id}
                                                    className={`rating-emoji ${Number(val?.rating) === Number(item.id) ? "active" : "inactive"}`}
                                                >
                                                    {item.label}
                                                </span>
                                            ))}
                                        </Box>
                                    </Box>

                                    {/* Review Text */}
                                    {val?.description && (
                                        <CustomTypography className="review-message" label={val?.description} />
                                    )}

                                    {/* Status */}
                                    {val?.is_replied ?
                                        <Chip
                                            icon={<CheckCircleOutline />}
                                            label="Replied"
                                            className="reply-replied-chip"
                                        />
                                        :
                                        <Chip
                                            icon={<AccessTime />}
                                            label="Awaiting Reply"
                                            className="reply-awaiting-chip"
                                        />
                                    }
                                </Card>
                            ))
                        )
                    }
                </Box>

                {rowCount > 0 &&
                    <CustomPagination
                        paginationModel={paginationModel}
                        setPaginationModel={setPaginationModel}
                        total={rowCount}
                    />
                }

                <ReviewDetailsModal
                    open={reviewDetailsModal}
                    handleClose={() => setReviewDetailsModal(false)}
                    reviewData={reviewData}
                />

                <ReviewReportModal
                    open={reviewReportModal}
                    handleClose={() => setReviewReportModal(false)}
                    reviewData={reviewData}
                />
            </Card>
        </MainContainer>
    )
}

export default ManageReviewsContainer;